import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { useSelector } from 'react-redux';
import { iRootState } from '../redux/store';

const RemainingTotal = function RemainingTotal(): React.ReactElement {
  const remainingTotal = useSelector(
    (state: iRootState) => state.paymentTerms.remainingTotal
  );
  const termCount =
    useSelector((state: iRootState) =>
      Math.max(...state.paymentTerms.terms.map(t => t.termOrder))
    ) + 1;

  return (
    <Grid container>
      <Grid item xs={6}>
        <Typography>
          <FormattedMessage
            id='PaymentTerms.NumberOfTerms'
            defaultMessage='Number of terms: {termCount}'
            values={{ termCount }}
          />
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage
            id='PaymentTerms.Remaining'
            defaultMessage='Remaining'
          />
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography color='secondary'>
          <FormattedNumber
            value={remainingTotal}
            currency='USD'
            style='currency'
          />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default RemainingTotal;
